import { styled } from "@mui/material/styles";
import { Roles } from "./ChatBox";
import { Box } from "@mui/system";
import { IconButton } from "@mui/material";
import { ramps, rolesFor } from "../../../common/theme/brandTokens";

interface ChatBoxProps {
  role: Roles;
}

export const ActionsBar = styled("div")<ChatBoxProps>(({ role }) => ({
  position: "absolute",
  bottom: -30,                 // matches your current layout
  left: role === "system" ? 0 : "auto",
  right: role === "user" ? 0 : "auto",
  marginLeft: 20,
  display: "flex",
  alignItems: "center",
  gap: 6,
  // Lets the bar (and the timestamp within it) overflow the bubble's own
  // width on short messages, rather than wrapping or getting clipped.
  whiteSpace: "nowrap",
}));

export const ActionsIconGroup = styled("div")(() => ({
  display: "flex",
  alignItems: "center",
  gap: 2,
  transition: "opacity 120ms ease-in-out",
}));

export const ActionsTimestamp = styled("span")(({ theme }) => ({
  fontSize: 11,
  color: theme.palette.text.disabled,
  whiteSpace: "nowrap",
  cursor: "default",
  transition: "opacity 120ms ease-in-out",
}));

export const ActionIconButton = styled(IconButton)(({ theme }) => ({
  width: 25,
  height: 25,
  borderRadius: 5,
  backgroundColor: "transparent",
  "&:hover": { backgroundColor: theme.palette.action.hover },
}));

export const PatientBox = styled(Box)(({ theme }) => ({
  width: "100%",
  maxWidth: "100%",
  boxSizing: "border-box",
  padding: theme.spacing(2),
  paddingBottom: theme.spacing(1),
  backgroundColor: theme.palette.mode === "dark" ? theme.palette.grey[900] : theme.palette.background.paper,
  borderRadius: theme.spacing(2),
  alignSelf: "flex-start",
}));

export const ChatBoxOuterWrapper = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "flex-end",
  flexDirection: "column",
  marginTop: theme.spacing(3)
}));

export const ChatBoxInnerWrapper = styled("div")(({ theme }) => ({
  width: "100%",
  padding: 1,
  marginBottom: 20,
  display: "flex",
  alignItems: "flex-start",
}));

interface ChatBoxProps {
  role: Roles;
}

export const ChatBox = styled("div")<ChatBoxProps>(({ theme, role }) => ({
  gap: 20,
  maxWidth: "90%",
  // Brand-template chat bubbles: assistant ("ai") = neutral surface
  // (#F5F3EC light / elevated #302E2A dark); user ("me") = steel-blue primary fill.
  color: role === "system" ? theme.palette.text.primary : theme.palette.primary.contrastText,
  backgroundColor:
    role === "system"
      ? theme.palette.mode === "dark"
        ? rolesFor(true).elevated
        : ramps.neutral[50]
      : theme.palette.primary.main,
  // AI ("ai") bubble uses taller vertical padding; user ("me") keeps the original 8px/24px.
  padding: role === "system" ? "18px 24px" : `${theme.spacing(1)} ${theme.spacing(3)}`,
  borderRadius: 15,
  borderBottomRightRadius: role === "user" ? 4 : 15,
  borderBottomLeftRadius: role === "system" ? 4 : 15,
  marginBottom: role === 'user' ? theme.spacing(-3) : 0,
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: role === "user" ? "flex-end" : "flex-start",
  position: "relative",
  overflow: "visible",
}));

// Note: StyledIconButton removed because it wasn't used elsewhere.
